import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d72d1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }

import { UiInput } from '@/ui-kit';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantityItem',
  props: {
    modelValue: null,
    loading: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update:modelValue', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	modelValue: number;
	loading: boolean;
};





const latestValue = ref(props.modelValue);

function decrement() {
	if (props.loading) {
		return;
	}

	if (props.modelValue - 1 === 0) {
		return;
	}

	emit('update:modelValue', props.modelValue - 1);
}

function increment() {
	if (props.loading) {
		return;
	}

	emit('update:modelValue', props.modelValue + 1);
}

function onBlur() {
	if (!latestValue.value) {
		latestValue.value = props.modelValue;
	} else {
		emit('update:modelValue', latestValue.value);
	}
}

watch(
	() => props.modelValue,
	() => {
		latestValue.value = props.modelValue;
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex select-none items-center bg-white w-6 cursor-pointer justify-center h-22px border-0 border-r border-solid transition hover:shadow-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (decrement()))
    }, " - "),
    _createVNode(_unref(UiInput), {
      min: 1,
      max: 100,
      type: "number",
      class: "!p-0 !m-0 number-input",
      name: "quantity",
      modelValue: latestValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
				latestValue.value = parseInt($event, 0)
			)),
      onBlur: onBlur,
      disabled: __props.loading
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", {
      class: "flex select-none items-center bg-white justify-center cursor-pointer w-6 h-22px border-0 border-l border-solid transition hover:shadow-sm",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (increment()))
    }, " + ")
  ]))
}
}

})